const ALL_COMPONENTS = {
  OBJECTS_TABLE: "records_table",
  OBJECT_TABLE: "record_table",
  ROLLUP_METRIC: "rollup",
  SCORE: "score",
  GRAPH: "graph",
  CALENDAR: "calendar",
  MILESTONE: "milestone",
  ACTIONS_TABLE: "action_table",
  ACTION_TABLE: "action_table",
  STANDARD_METRICS: "standard_metrics",
  NEW_RESOURCES: "new_resources",
  TEAM_CHAT: "team_chat",
  WHATSAPP_CHAT: "whatsapp_chat",
  SEND_EMAIL: "send_email",
  LEADS_TABLE: "lead_table",
  JOURNEY: "journey",
  OUTSTANDING_CASES_TABLE: "outstanding_cases_table",
  PROSPECTING_TABLE: "prospecting_table",
  EXPANSION_LIST_TABLE: "expansion_table",
  GROWTH_MATRIX: "growth_matrix",
  SUGGESTED_LIST: "suggested_list",
  FIND_LEADS: "find_leads",
  CUSTOMER_JOURNEYS: "customer_journeys",
  FORECASTING_TABLE: "forecast_table",
  FORECASTING_METRIC: "forecasting_metric",
  COMPANY_OVERVIEW_COMPANY_DETAILS: "company_profile_company_overview_company_details_component",
  COMPANY_PROFILE_COMPANY_INSIGHTS: "company_profile_company_insights",
  COMPANY_PROFILE_COMPANY_MAP: "company_profile_company_map",
  COMPANY_PROFILE_ACTIONS: "company_profile_actions",
  COMPANY_PROFILE_CHECKLIST: "company_profile_checklists",
  CHECKLIST: "checklist",
  COMPANY_MAP: "company_map",
  TEXT: "text",
  NOTES: "notes",
  DATA_SOURCE: "data_source",
  IMAGE: "image",
  VIDEO: "video",
  TEAM_CARD: "team_card",
  ASSETS: "assets",
  OVERVIEW: "overview",
  RECORD_TITLE: "record_title",
  INSIGHTS: "insights",
  KEY_PEOPLE: "key_people",
  LAST_TOUCH: "last_touch",
  LAST_QUALITY_TOUCH: "last_quality_touch",
  OWNERS: "owners",
  AI_INSIGHTS: "ai_insights",
  AI_QUICK_ACTIONS: "ai_quick_actions"
}

const COMPONENT_CODES = {
  records_table: "ots",
  record_table: "ot",
  rollup_metric: "rm",
  score: "sc",
  graph: "gr",
  calendar: "cal",
  milestone: "ms",
  actions_table: "ats",
  action_table: "at",
  standard_metrics: "sm",
  new_resources: "nr",
  team_chat: "tc",
  send_email: "se",
  leads_table: "lt",
  journey: "jn",
  outstanding_cases_table: "oc",
  prospecting_table: "pt",
  expansion_list_table: "et",
  growth_matrix: "gm",
  suggested_list: "sl",
  find_leads: "fl",
  customer_journeys: "cj",
  forecasting_table: "ft",
  forecasting_metric: "fm",
  company_profile_company_overview_company_details_component: "cd",
  company_profile_company_insights: "ci",
  company_profile_company_map: "cm",
  company_profile_actions: "ca",
  company_profile_checklists: "cc",
  checklist: "cl",
  company_map: "cm1",
  text: "tx",
  notes: "nt",
  data_source: "ds",
  image: "im",
  video: "vd",
  team_card: "tcd",
  assets: "as",
  overview: "ov",
  record_title: "rt",
  insights: "in",
  key_people: "kp",
  last_touch: "lt1",
  last_quality_touch: "lq",
  owners: "ow",
  ai_insights: "ai",
  ai_quick_actions: "aq"
}

// Function to generate the next unique ID for a given component type
function getNextComponentId(component_type, existing_components) {
  const component_code = COMPONENT_CODES[component_type]

  if (!component_code) {
    throw new Error(`Component type not found ${component_type}`)
  }

  // Filter to find components with matching references
  const matching_components = existing_components.filter((comp) => comp.props.component_reference.startsWith(component_code + "-"))

  // Extract numeric IDs from the references without modifying the original component
  const numeric_ids = matching_components
    .map((comp) => {
      const reference = comp.props.component_reference
      const id = parseInt(reference.replace(component_code + "-", ""), 10)
      return id
    })
    .filter((num) => !isNaN(num)) // Filter valid numbers

  // Find the next available ID
  const next_id = numeric_ids.length > 0 ? Math.max(...numeric_ids) + 1 : 1

  return `${component_code}-${next_id}`
}

export { ALL_COMPONENTS, COMPONENT_CODES, getNextComponentId }
